import React from "react";

export default function Check() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73047 11.2812C6.00391 11.5547 6.46875 11.5547 6.74219 11.2812L14.7812 3.24219C15.0547 2.96875 15.0547 2.50391 14.7812 2.23047L13.7969 1.24609C13.5234 0.972656 13.0859 0.972656 12.8125 1.24609L6.25 7.80859L3.16016 4.74609C2.88672 4.47266 2.44922 4.47266 2.17578 4.74609L1.19141 5.73047C0.917969 6.00391 0.917969 6.46875 1.19141 6.74219L5.73047 11.2812Z"
        fill="currentColor"
      />
    </svg>
  );
}
